import Vue from 'vue';
import Vuex from 'vuex';

//模块
import user from './modules/user';
import app from './modules/app';

Vue.use(Vuex);

const store = new Vuex.Store({
    modules: {
      app,
      user
    }
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js